import { Component, Input, OnInit,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ActionData } from 'src/app/performance-dashboard/model/performance.model';
import { PerformanceService } from '../../../services/performance.service';
import { PerformancePanelComponent } from '../../performance-panel/performance-panel.component';
import { ConstantsService } from '../../../../shared/services/constants.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-action-tracker',
  templateUrl: './action-tracker.component.html',
  styleUrls: ['./action-tracker.component.css']
})
export class ActionTrackerComponent implements OnInit {
  @Input() ActionData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  @ViewChild('child1') child1:PerformancePanelComponent;
  clonedAction: { [s: string]: ActionData } = {};
  ATData : any;
  data : any;
  DisableExport : boolean = false;

  constructor(private PDService: PerformanceService,private router: Router) { }

  ngOnInit(): void {

  }


  onRowEditInit(Action: ActionData) {
    this.clonedAction[Action.Id] = { ...Action };
    this.DisableExport = true;
  }

  onRowEditSave(Action: ActionData, index: number) {
    if (Action.Id > 0) {

      if (this.clonedAction[Action.Id].Open != Action.Open) {
        this.ActionData[this.ActionData.length - 1].Open = this.ActionData[this.ActionData.length - 1].Open - this.clonedAction[Action.Id].Open + Action.Open;
      }
      if (this.clonedAction[Action.Id].Done != Action.Done) {
        this.ActionData[this.ActionData.length - 1].Done = this.ActionData[this.ActionData.length - 1].Done - this.clonedAction[Action.Id].Done + Action.Done;
      }
      if (this.clonedAction[Action.Id].Accepted != Action.Accepted) {
        this.ActionData[this.ActionData.length - 1].Accepted = this.ActionData[this.ActionData.length - 1].Accepted - this.clonedAction[Action.Id].Accepted + Action.Accepted;
      }
      if (this.clonedAction[Action.Id].Closed != Action.Closed) {
        this.ActionData[this.ActionData.length - 1].Closed = this.ActionData[this.ActionData.length - 1].Closed - this.clonedAction[Action.Id].Closed + Action.Closed;
      }
      if (this.clonedAction[Action.Id].PassedDueDate != Action.PassedDueDate) {
        this.ActionData[this.ActionData.length - 1].PassedDueDate = this.ActionData[this.ActionData.length - 1].PassedDueDate - this.clonedAction[Action.Id].PassedDueDate + Action.PassedDueDate;
      }

      delete this.clonedAction[Action.Id];
    }
    this.DisableExport = Object.keys(this.clonedAction).length > 0 ? true : false;
  }

  onRowEditCancel(Action: ActionData, index: number) {
    this.ActionData[index] = this.clonedAction[Action.Id];
    delete this.clonedAction[Action.Id];
    this.DisableExport = Object.keys(this.clonedAction).length > 0 ? true : false;
  }

  GetActionTrackerSelectedDetails(UnitId,Unit,Column){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName":"Action Tracker",
        "Component":Unit === "Total" ? 0 : UnitId,
        "Column":Column,
        "ComponentName":Unit
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetActionTrackerSelectedDetails.bind(this));
  }
  callbackMethodForGetActionTrackerSelectedDetails(response){
    if(response.Success)
    this.ATData = response.Result;
  }

  Redirect(value,processId)
  {
  //this.router.navigate(['/actiontracker/all-action-details', value, { processId:processId }])
  window.open(ConstantsService.URL.APP + ['/actiontracker/all-action-details/'+value+';processId='+processId], '_self');
  }
  
  getData($event){
    this.data=$event;
  }

  //BOC Pritesh
  exportToExcel()
  {

  let element = document.getElementById('ActionTableToExport');
  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
  ws['!ref'] = ws['!ref'].replace('G','F');//to remove Actions Column
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */  
  XLSX.writeFile(wb, "ActionTracker.xlsx");

  }
  //EOC Pritesh

}
